// extracted by mini-css-extract-plugin
export var box = "DdPqr";
export var container = "Thnbs";
export var name = "_5yTNq";
export var photo = "kIw3T";
export var proBadge = "_82EVo";
export var review = "_2jv1m";
export var star = "JR92J";